import FaqItemArrowUi from 'common/components/entities/Faq/ui/FaqItemArrowUi'
import FaqItemContentUi from 'common/components/entities/Faq/ui/FaqItemContentUi'
import FaqItemTitleUi from 'common/components/entities/Faq/ui/FaqItemTitleUi'
import FaqItemUi from 'common/components/entities/Faq/ui/FaqItemUi'
import React, { MouseEvent } from 'react'

import { FaqInterface } from 'src/shared/entities/faq/faq.schema'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'

export type FaqItemProps = StrictRequired<
  Pick<
    FaqInterface,
    | 'showIcons'
    | 'mobileShowIcons'
    | 'itemBorderRadius'
    | 'itemPadding'
    | 'mobileItemPadding'
    | 'backgroundColor'
    | 'mobileBackgroundColor'
    | 'titleColor'
    | 'mobileTitleColor'
    | 'titleFontSize'
    | 'mobileTitleFontSize'
    | 'titleFontFamily'
    | 'mobileTitleFontFamily'
    | 'titleFontStyle'
    | 'mobileTitleFontStyle'
    | 'titleFontWeight'
    | 'mobileTitleFontWeight'
    | 'fontFileId'
    | 'mobileFontFileId'
    | 'iconClassName'
    | 'closedIconClassName'
    | 'iconColor'
    | 'mobileIconColor'
    | 'boxShadow'
    | 'mobileBoxShadow'
  >
> & {
  title: string
  expanded: boolean
  children: React.ReactElement
  toggleCollapse?: (e: MouseEvent<HTMLDivElement>) => void
}

const FaqItem = ({
  backgroundColor,
  mobileBackgroundColor,
  titleFontSize,
  mobileTitleFontSize,
  titleColor,
  mobileTitleColor,
  title,
  titleFontFamily,
  titleFontStyle,
  titleFontWeight,
  fontFileId,
  mobileTitleFontWeight,
  mobileTitleFontStyle,
  mobileTitleFontFamily,
  mobileFontFileId,
  expanded,
  children,
  itemPadding,
  mobileItemPadding,
  itemBorderRadius,
  toggleCollapse,
  iconClassName,
  closedIconClassName,
  iconColor,
  mobileIconColor,
  boxShadow,
  mobileBoxShadow,
  showIcons = true,
  mobileShowIcons = true,
}: FaqItemProps) => {
  const arrowClassName = expanded
    ? iconClassName
    : closedIconClassName || iconClassName

  return (
    <FaqItemUi
      backgroundColor={backgroundColor}
      mobileBackgroundColor={mobileBackgroundColor}
      padding={itemPadding}
      mobilePadding={mobileItemPadding}
      borderRadius={itemBorderRadius}
      onClick={e => toggleCollapse?.(e)}
      boxShadow={boxShadow}
      mobileBoxShadow={mobileBoxShadow}
    >
      <FaqItemTitleUi
        fontSize={titleFontSize}
        mobileFontSize={mobileTitleFontSize}
        color={titleColor}
        mobileColor={mobileTitleColor}
        fontFamily={titleFontFamily}
        fontStyle={titleFontStyle}
        fontWeight={titleFontWeight}
        fontFileId={fontFileId}
        mobileFontWeight={mobileTitleFontWeight}
        mobileFontStyle={mobileTitleFontStyle}
        mobileFontFamily={mobileTitleFontFamily}
        mobileFontFileId={mobileFontFileId}
        expanded={expanded}
      >
        {title}
        <FaqItemArrowUi
          showIcons={showIcons}
          mobileShowIcons={mobileShowIcons}
          expanded={expanded}
          hasClosedIcon={!!closedIconClassName}
          iconColor={iconColor}
          mobileIconColor={mobileIconColor}
          className={arrowClassName}
        />
      </FaqItemTitleUi>
      <FaqItemContentUi expanded={expanded} onClick={e => e.stopPropagation()}>
        {children}
      </FaqItemContentUi>
    </FaqItemUi>
  )
}

export default FaqItem
